import {
    Button,
    Divider,
    Stack,
    Box,
    Typography
} from "@mui/material";
import FormInput from '../form/form-input';
import React, { useContext, useState, useRef } from "react";
import PropTypes from 'prop-types';
import GoogleOAuthChoice from "./Google/GoogleOAuthChoice";
import FacebookOAuthChoice from "./Facebook/FacebookOAuthChoice";
import MicrosoftOAuthChoice from './Microsoft/MicrosoftOAuthChoice';
import auth from "../utils/auth";
import useForm from '../hooks/useForm';
import { ConfigContext } from '../Config/ConfigContext';
import http from "../utils/http";
import VerificationEmail from './VerificationEmail';

Auth.propTypes = {
    LoginHeaderLogo: PropTypes.string,
    signInBlurb: PropTypes.string,
    signInBackgroundColor: PropTypes.string,
    children: PropTypes.element.isRequired,
};

/*
 * This should be the landing page for Auth with all of the 
 * customized buttons where users choose to render the 
 * Google, Facebook, or Twitter provider with the app children
* */
export default function Auth(props) {

    //const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated())

    //const [useGoogleOAuth, setUseGoogleOAuth] = useState(false);
    const [useFacebookOAuth, setUseFacebookOAuth] = useState(false);
    const [useShadowAuth, setUseShadowAuth] = useState(false);
    //const [useMicrosoftAuth, setUseMicroosftAuth] = useState(false);
    //const [choiceChosen, setChoiceChosen] = useState(false);
    const { config } = useContext(ConfigContext);
    const [authSuccess, setAuthSuccess] = useState(auth.isAuthenticated());

    const googleBtnRef = useRef(null);

    const {
        LoginHeaderLogo,
        signInBlurb,
        signInBackgroundColor,
    } = props;

    const {
        state,
        onChange,
    } = useForm({
        initialState: {
            email: ''
        }
    });

    return (
        <React.Fragment>

            {(!authSuccess && !useShadowAuth) &&
                <Box
                    className="auth-container"
                    backgroundColor={signInBackgroundColor || '#ffffff'}
                    sx={{ width: '100%', height: '100%' }}
                    display="flex"
                    alignItems="center"
                    justifyContent={'start'}
                    flexDirection={'column'}
                >

                    {LoginHeaderLogo && (
                        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{ margin: '20px', maxWidth: '400px', width: '100%' }}>
                            <img style={{ maxWidth: '100%', height: '100%' }} src={LoginHeaderLogo} alt="login header" />
                        </Box>
                    )}

                    <Box 
                        padding='20px' 
                        sx={{ 
                            backgroundColor: 'white', 
                            width: '100%', 
                            maxWidth: '335px', 
                            borderColor: '#E0E0E0',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '20px' 
                        }}
                    >
                        <Stack direction="column" alignItems="center" justifyContent="center" gap='4px'>
                            <Typography sx={{ fontSize: '24px', fontWeight: 800, lineHeight: '28.8px' }}>Sign in</Typography>
                            {signInBlurb && (
                                <Typography sx={{ color: '#5B626E', fontSize: '14px', lineHeight: '21px', fontWeight: 700, width: '60%', textAlign: 'center' }}>{signInBlurb}</Typography>
                            )}
                        </Stack>
                        <Stack gap="16px" sx={{ marginTop: '20px' }} direction='column' justifyContent='center'>
                            {config.googleOAuth.enabled &&
                                <React.Fragment>
                                    <GoogleOAuthChoice parentBtnRef={googleBtnRef} setAuthSuccess={setAuthSuccess} {...props} />
                                    <Button
                                        ref={googleBtnRef}
                                        sx={{
                                            //borderRadius: '90px',
                                            //border: '1px solid #5b626E',
                                            color: '#1B1C1E',
                                            textTransform: 'initial',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontWeight: '700',
                                            fontSize: '15px'
                                        }}
                                        onClick={() => {
                                            //setUseGoogleOAuth(true);
                                            setUseFacebookOAuth(false);
                                            //setChoiceChosen(true);
                                        }}
                                    >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_560_4093)">
                                                <path d="M23.766 12.2763C23.766 11.4605 23.6999 10.6404 23.5588 9.83789H12.24V14.4589H18.7217C18.4528 15.9492 17.5885 17.2676 16.323 18.1054V21.1037H20.19C22.4608 19.0137 23.766 15.9272 23.766 12.2763Z" fill="#4285F4" />
                                                <path d="M12.2401 24.0008C15.4766 24.0008 18.2059 22.9382 20.1945 21.1039L16.3276 18.1055C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3912C3.55371 21.4434 7.7029 24.0008 12.2401 24.0008Z" fill="#34A853" />
                                                <path d="M5.50253 14.3002C4.99987 12.8099 4.99987 11.196 5.50253 9.70569V6.61475H1.51649C-0.18551 10.0055 -0.18551 14.0004 1.51649 17.3912L5.50253 14.3002Z" fill="#FBBC04" />
                                                <path d="M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z" fill="#EA4335" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_560_4093">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Continue with Google
                                    </Button>
                                </React.Fragment>
                            }
                            {config.facebookOAuth.enabled &&
                                <Button
                                    sx={{
                                        borderRadius: '90px',
                                        border: '1px solid #5b626E',
                                        color: '#1B1C1E',
                                        textTransform: 'initial',
                                        padding: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontWeight: '700',
                                        fontSize: '15px'
                                    }}
                                    onClick={() => {
                                        setUseFacebookOAuth(true);
                                        //setUseGoogleOAuth(false);
                                        //setChoiceChosen(true);
                                    }}
                                >Continue with Facebook
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="25px" viewBox="0 0 40 40">
                                        <linearGradient id="a" x1="-277.375" x2="-277.375" y1="406.6018" y2="407.5726" gradientTransform="matrix(40 0 0 -39.7778 11115.001 16212.334)" gradientUnits="userSpaceOnUse">
                                            <stop offset="0" stop-color="#0062e0" />
                                            <stop offset="1" stop-color="#19afff" />
                                        </linearGradient>
                                        <path fill="url(#a)" d="M16.7 39.8C7.2 38.1 0 29.9 0 20 0 9 9 0 20 0s20 9 20 20c0 9.9-7.2 18.1-16.7 19.8l-1.1-.9h-4.4l-1.1.9z" />
                                        <path fill="#fff" d="m27.8 25.6.9-5.6h-5.3v-3.9c0-1.6.6-2.8 3-2.8H29V8.2c-1.4-.2-3-.4-4.4-.4-4.6 0-7.8 2.8-7.8 7.8V20h-5v5.6h5v14.1c1.1.2 2.2.3 3.3.3 1.1 0 2.2-.1 3.3-.3V25.6h4.4z" />
                                    </svg>
                                </Button>}
                            {config.microsoftOAuth.enabled &&
                                <React.Fragment>
                                    <MicrosoftOAuthChoice
                                        setAuthSuccess={setAuthSuccess}
                                        {...props}
                                    />
                                </React.Fragment>
                            }
                        </Stack>
                        {config.emailAuth.enabled &&
                            <React.Fragment>
                                <Stack sx={{ margin: '16px 0px 0px' }} gap="16px">
                                    <Divider />
                                </Stack>
                                <Stack gap="16px">
                                    <FormInput
                                        label='Email'
                                        path='email'
                                        value={state.values.email}
                                        error={state.errors.email}
                                        onChange={onChange}
                                    />
                                    <Button
                                        sx={{
                                            borderRadius: '90px',
                                            border: '1px solid #5b626E',
                                            color: '#1B1C1E',
                                            textTransform: 'initial',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontWeight: '700',
                                            fontSize: '15px'
                                        }}
                                        onClick={async () => {
                                            await http.get({}, `${config.uri.base}/auth/init?signInPlatform=shadow&email=${state.values.email}`);
                                            setUseShadowAuth(true);
                                        }}
                                    >Continue</Button>
                                </Stack>
                            </React.Fragment>
                        }
                    </Box>
                </Box>
            }
            {useShadowAuth && <VerificationEmail {...props} />}
            {useFacebookOAuth && <FacebookOAuthChoice setAuthSuccess={setAuthSuccess} {...props} />}
            {authSuccess && (props.children)}
        </React.Fragment>
    );
} 
